import { render, staticRenderFns } from "./SelectTaskTypeModal.vue?vue&type=template&id=253cae1e&scoped=true&"
import script from "./SelectTaskTypeModal.vue?vue&type=script&lang=js&"
export * from "./SelectTaskTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectTaskTypeModal.vue?vue&type=style&index=0&id=253cae1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253cae1e",
  null
  
)

export default component.exports